import React from "react";
import MuiCardHeader, { CardHeaderProps } from "@material-ui/core/CardHeader";

const CardHeader = ({ children, ...others }: CardHeaderProps) => (
  <MuiCardHeader {...others} />
);

export default CardHeader;
